export interface IRegisteredTrackerEvent {
    latitude?: string;
    longitude?: string;
}
